/**
 * 好会员接口相关
 * @author ytl
 */

import Qs from 'qs'
import axios from 'axios';
import { INTERACE_HHY_BASE_URL } from 'src/config/params-local';
import {setSessionStorageItem, getSessionStorageItem} from 'components/api/utils';

// 接口自定义code状态
export const RESPONSE_CODE_SUCCESS = 'SUCCESS';
export const RESPONSE_CODE_FAIL = 'FAIL';

// 客户端类型
export const CLIENT_WECHAT = 'WECHAT'    // 微信
export const CLIENT_ALIPAY = 'ALIPAY'    // 支付宝

// 会员类型
export const USER_LEVEL_FANS = 'FANS';  // 粉丝
export const USER_LEVEL_REGISTE = 'REGISTE';  // 注册会员
export const USER_LEVEL_PREPAID = 'PREPAID';  // 储值会员会员

/**
 * 创建axios实例
 * @return {axios}
 */
export function createHttp () {
  let $httpHhy = axios.create({
    baseURL: INTERACE_HHY_BASE_URL,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'Cache-Control': 'no-cache'
    },
    timeout: 30000
  });

  $httpHhy.interceptors.response.use(res => {
    return res.data;
  }, err => {
    let url = err.request ? err.request.url : '';
    if (url !== '/log/we-app') {
      let responseData = err.response ? err.response.data : null;
      logging({
        request: err.config,
        responseData,
        err: responseData ? null : err
      });
    }
    let errorInfo = err.response ? err.response.data : err;
    return Promise.reject(errorInfo);
  });
  return $httpHhy;
}

/**
 * 获取code url
 * @param params
 * @return {String}
 */
export function getAuthCodeUrl (params, backUrl) {
  let {
    branchId,
    clientType,
    businessType,
    authId = ''
  } = params;

  let url = INTERACE_HHY_BASE_URL + '/get-code/branch_id/' + branchId +
    '/client_type/' + clientType +
    '/business_type/' + businessType +
    '/auth_id/' + authId;
  url += '?back_uri=' + encodeURIComponent(backUrl);
  return url;
}

/**
 * 初始化会员信息
 * @param {Object} params 请求参数
 * @param {Object} authQuery 微信/支付宝授权信息（code、state、appid）
 * @return {Promise}
 */
export function initUserIdentity (params, authQuery) {
  let {
    branchId = 0,
    clientType,
    businessType,
    authId = '',
    tableId = 0,
    tableNo = 0,
    isJC = 'NO',
    menuType = ''
  } = params;

  let url = '/user/branch_id/' + branchId +
    '/client_type/' + clientType +
    '/business_type/' + businessType +
    '/auth_id/' + authId;

  url += '?' + Qs.stringify(authQuery);

  let $httpHhy = createHttp();

  $httpHhy.interceptors.response.use(res => {
    if (res.levelType === '') {
      let errMsg = {message: '会员信息有误, 请检查商户信息是否配置正确'};
      return Promise.reject(errMsg);
    }
    setSessionStorageItem('userIdentity', {
      businessType: businessType,
      orgId: res.orgId,
      uid: res.uid,
      authId: res.authId,
      authUserName: res.authUserName,   // 第三方用户名（公众号/支付宝partnerId）
      branchId: branchId,
      tableId: tableId,
      tableNo: tableNo,
      userId: res.id,
      showname: res.showname,
      mobile: res.mobile,
      levelType: res.levelType,
      userThirdValue: res.thirdChannelValue,
      appId: res.appId,
      isJC: isJC,
      menuType: menuType
    });
    return res;
  }, err => {
    return Promise.reject(err);
  });

  return $httpHhy.get(url);
}

/**
 * 获取当前会员信息
 * @param key 会员信息key值，null时返回会员所有信息
 * @returns Object|string|null
 */
export function getUserIdentity (key = null) {
  let userIdentity = getSessionStorageItem('userIdentity');
  if (key === null) {
    return userIdentity;
  }
  return userIdentity ? userIdentity[key] : null;
}

/**
 * 更新当前会员信息
 * example:
 * updateUserIdentity('businessType', 'TS');
 * updateUserIdentity('', {businessType: 'TS'});
 * @param key 要更新的key，传空时表示更新多个字段
 * @param value 要更新的值，key为空时value应传对象
 */
export function updateUserIdentity (key = '', value) {
  let userIdentity = getUserIdentity(),
    updateSource = key === '' ? value : {[key]: value};
  Object.assign(userIdentity, updateSource);
  setSessionStorageItem('userIdentity', userIdentity);
}

/**
 * 根据userId获取会员信息（从服务器查询）
 * @param userId
 * @return {Promise}
 */
export function getUserInfoByUserId (userId = 0) {
  let userIdentity = getUserIdentity();
  userId = userId || userIdentity.userId;
  let url = '/user/uid/' + userIdentity.uid + '/user_id/' + userId;
  let $httpHhy = createHttp();
  return $httpHhy.get(url);
}

/**
 * 获取会员可用卡券
 * @param userId
 * @return {Promise}
 */
export function getUsercardList (userId = 0) {
  let userIdentity = getUserIdentity();
  userId = userId || userIdentity.userId;
  let url = '/usercard/uid/' + userIdentity.uid +
    '/user_id/' + userId +
    '/branch_id/' + userIdentity.branchId + '?has_discount=1';
  let $httpHhy = createHttp();
  return $httpHhy.get(url);
}

/**
 * 获取低分抵扣比例
 * @return {Promise}
 */
export function getPointsConfig () {
  let uid = getUserIdentity('uid');
  let url = '/points-config/uid/' + uid;
  let $httpHhy = createHttp();
  return $httpHhy.get(url);
}

/**
 * 发送验证短信
 * @param mobile
 * @return {Promise}
 */
export function sendSmsCode (mobile) {
  let userIdentity = getUserIdentity();
  let url = '/sms/send-sms-code';
  let $httpHhy = createHttp();
  return $httpHhy.post(url, {
    uid: userIdentity.uid,
    auth_id: userIdentity.authId,
    user_id: userIdentity.userId,
    mobile: mobile,
    operationChannel: 'SELF_ORDER',
    operationType: 'USER_UPDATE'
  });
}
/**
 * 更新会员信息
 * @param params Object {
 *    mobile: mobile,
 *    mobileCode: mobileCode,
 *    name: name
 *  }
 * @return {Promise}
 */
export function updateUserInfo (params) {
  let {
    mobile = '',
    mobileCode = '',
    name = '',
    sex = '',
    birthday = ''
  } = params;
  let userIdentity = getUserIdentity();
  let url = '/user/auth_id/' + userIdentity.authId + '/user_id/' + userIdentity.userId;
  let $httpHhy = createHttp();
  $httpHhy.interceptors.response.use(res => {
    if (res.code === RESPONSE_CODE_SUCCESS) {
      updateUserIdentity('mobile', mobile);
      res.userId && updateUserIdentity('userId', res.userId);
    }
    return res;
  }, err => {
    return Promise.reject(err);
  });
  return $httpHhy.patch(url, {
    mobile: mobile,
    mobile_code: mobileCode,
    name: name,
    sex: sex,
    birthday: birthday,
    operationChannel: userIdentity.businessType,
    registerShopId: userIdentity.branchId
  });
}

/**
 * 添加配送地址
 * @param params
 * @return {Promise}
 */
export function createUserShippingAddress (params) {
  let userIdentity = getUserIdentity();
  let url = '/user-shipping-address';
  let $httpHhy = createHttp();
  return $httpHhy.post(url, {
    uid: userIdentity.uid,
    user_id: userIdentity.userId,
    username: params.username,
    sex: params.sex,
    mobile: params.mobile,
    address: params.address,
    detail: params.detail,
    longitude: params.longitude,
    latitude: params.latitude,
    is_default: params.is_default
  });
}

/**
 * 修改配送地址
 * @param params
 * @return {Promise}
 */
export function updateUserShippingAddress (params) {
  let userIdentity = getUserIdentity();
  let url = '/user-shipping-address/id/' + params.id;
  let $httpHhy = createHttp();
  return $httpHhy.put(url, {
    id: params.id,
    uid: userIdentity.uid,
    user_id: userIdentity.userId,
    username: params.username,
    sex: params.sex,
    mobile: params.mobile,
    address: params.address,
    detail: params.detail,
    longitude: params.longitude,
    latitude: params.latitude,
    is_default: params.is_default
  });
}

/**
 * 删除配送地址
 * @param id
 * @return {Promise}
 */
export function deleteUserShippingAddress (id) {
  let userIdentity = getUserIdentity();
  let url = '/user-shipping-address/uid/' + userIdentity.uid +
    '/user_id/' + userIdentity.userId +
    '/id/' + id;
  let $httpHhy = createHttp();
  return $httpHhy.delete(url);
}

/**
 * 查询配送地址列表
 * @param isDefault
 * @return {Promise}
 */
export function getUserShippingAddressList (isDefault = '') {
  let userIdentity = getUserIdentity();
  let url = '/user-shipping-address/uid/' + userIdentity.uid +
    '/user_id/' + userIdentity.userId +
    '/is_default/' + isDefault;
  let $httpHhy = createHttp();
  return $httpHhy.get(url);
}

/**
 * 根据第三方信息查询会员信息, 如扫码口碑码后
 * @param params
 * @return {Promise}
 */
export function getUserByThirdChannelInfo (params) {
  let {
    thirdChannel,
    userThirdValue,
    merchant,
    shop = 0,
    businessType,
    tableId = 0,
    tableNo = ''
  } = params;
  let url = '/third-channel/' + thirdChannel +
    '/user/' + userThirdValue +
    '?businessType=' + businessType +
    '&merchant=' + merchant +
    '&shop=' + shop;
  let $httpHhy = createHttp();
  $httpHhy.interceptors.response.use(res => {
    if (res.levelType === '') {
      let errMsg = {message: '会员信息有误, 请检查商户信息是否配置正确'};
      return Promise.reject(errMsg);
    }
    setSessionStorageItem('userIdentity', {
      businessType: businessType,
      orgId: res.orgId,
      uid: res.uid,
      authId: res.authId,
      authUserName: res.authUserName,   // 第三方用户名（公众号/支付宝partnerId）
      branchId: res.branchId,
      tableId: tableId,
      tableNo: tableNo,
      userId: res.id,
      showname: res.showname,
      mobile: res.mobile,
      levelType: res.levelType,
      userThirdValue: userThirdValue,
      appId: res.appId
    });
    return res;
  }, err => {
    if (err.response && err.response.status === 422) {
      let data = err.response.data,
        msg = data && data[0] && data[0]['message'] ? data[0]['message'] : '获取会员失败';
      return Promise.reject({message: msg});
    }
    return Promise.reject(err);
  });
  return $httpHhy.get(url);
}

/**
 * 根据支付宝shop_id获取门店信息
 * @param {string} shopId
 * @return {Promise}
 */
export function getBranchInfoByAliShopId (shopId) {
  let url = '/ali-info/get-branch/ali_shop_id/' + shopId,
    $http = createHttp();
  return $http.get(url);
}
/**
 * 查询会员权益描述
 * /user-right/description/{uid}
 * @return {Promise}
 */
export function getUserRightDesc () {
  let uid = getUserIdentity().uid,
    url = `/user-right/description/${uid}`,
    $http = createHttp();
  return $http.get(url);
}

 /**
 * 判断卡券是否可用
 * 0. 是否可用于储值
 * 1.消费金额大于等于卡券抵扣条件
 * 2.卡券周几可用
 * 3.卡券可用时段
 * 4.卡券可用渠道
 * 5.卡券可用菜品（折扣券不能用于套餐）
 * @param card 卡券
 * @param totalPrice 总金额
 * @param foodList 订单菜 [{code（或goodsId）: '20007', foodType（或type）: 'SET_MEAL'}]
 * @param payType 支付方式
 * @return {boolean}
 */
export function ifCardUsable(card, totalPrice, foodList, payType) {
   // 嘉和世纪套餐不支持优惠券0516
   if (card.uid === '106') {
     let hasSetMeal = foodList.filter(food => {
       let foodType = food.foodType || food.type;
       return foodType === 'SET_MEAL';
     }); // 交集
     if (hasSetMeal.length > 0) {
       return false;
     }
   }
  // 是否可用于储值
  if (payType === 'CARDPAY' && card.canPrepaidUse !== 'Y') {
    return false;
  }
  // 消费金额大于等于卡券抵扣条件
  if (totalPrice < card.leastCost) {
    return false;
  }
  // 卡券周几可用
  let currentDate = new Date(),
    currentWeek = currentDate.getDay(),
    cardWeek = card.useWeek.split(',');
  if (cardWeek.includes('' + currentWeek) === false) {
    return false;
  }
  // 券可用时段
  let currentDaySeconds = currentDate.getHours() * 60 * 60 + currentDate.getMinutes() * 60 + currentDate.getSeconds();
  if (currentDaySeconds < card.dayBeginTime || currentDaySeconds > card.dayEndTime) {
    return false;
  }
  // 卡券可用渠道
  let cardUseChannel = card.useChannel.split(','),
    businessType = getUserIdentity('businessType');
  if (cardUseChannel.includes(businessType) === false) {
    return false;
  }
  // 卡券可用菜品（折扣券不能用于套餐）
  let cardFoodsCode = card.foodNoList;
  let cardType = card.cardType;
  if (cardFoodsCode) {
    let intersection = foodList.filter(food => {
      let foodCode = food.code || food.goodsId;
      let foodType = food.foodType || food.type;
      return cardFoodsCode.includes(foodCode) && (cardType !== 'DISCOUNT' || foodType !== 'SET_MEAL');
    }); // 交集
    if (intersection.length === 0) {
      return false;
    }
  }
  return true;
}

/**
 * 查询会员权益等级信息
 * /uid/{uid}/levelType/{levelType}
 * @param levelType
 */
export function getRightLevelDetail (levelType) {
  let uid = getUserIdentity('uid'),
    url = `/uid/${uid}/levelType/${levelType}`,
    $http = createHttp();
  return $http.get(url);
}
/**
 * 查询会员权益等级信息-嘉和世纪门店开业配置
 * /uid/{uid}/branch/{branch}/levelType/{levelType}
 * @param levelType
 * @param branch
 */
export function getRightLevelDetailByBranch (levelType, branch) {
  let uid = getUserIdentity('uid'),
    url = `/uid/${uid}/branch/${branch}/levelType/${levelType}`,
    $http = createHttp();
  return $http.get(url);
}

/**
 * 储值规则列表
 * /uid/5320/shop/8325/pay-rules
 * @param type
 */
export function getPayRules (type) {
  let {uid, branchId} = getUserIdentity();
  let url = `/uid/${uid}/shop/${branchId}/pay-rules?payrule_type=${type}`,
    $http = createHttp();
  return $http.get(url);
}

/**
 * 验证会员发送手机验证码（好友手机代付）
 * /check-user/send-code
 * @param mobile
 * @param code
 * @return {Promise}
 */
export function checkUserSendSmsCode (mobile, code) {
  let url = '/check-user/send-code';
  let {uid} = getUserIdentity();
  return createHttp().post(url, {
    uid,
    mobile,
    code
  });
}

/**
 * 查询领券活动
 * @param params
 */
export function getCouponActivity () {
  let {uid, branchId, businessType, userId} = getUserIdentity();
  let url = '/activity/card-first';
  return createHttp().post(url, {
    uid,
    branchId,
    channel: businessType,
    userId
  });
}
// 领取活动卡券 /activity/card-first/send
export function takeActivityCards (activityArr) {
  let {uid, branchId, businessType, userId} = getUserIdentity();
  let url = '/activity/card-first/send';
  return createHttp().post(url, {
    uid,
    branchId,
    channel: businessType,
    userId,
    activityArr
  });
}

/**
 * 提交投诉建议
 * @param {Object} payload
 * @return {Promise}
 */
export function submitFeedback (payload) {
  return createHttp().post('/feedback', payload);
}

/**
 * 客户端错误日志上传
 * @param content
 */
export function logging (content) {
  let identity = getUserIdentity() || {};
  let url = '/log/we-app';
  return createHttp().post(url, Object.assign({ appType: 'selfOrderH5' }, identity, content));
}
/**
 * 查询会员今日卡券核销历史
 */
export function userCardConsumeLogs (userId = 0) {
  let userIdentity = getUserIdentity();
  userId = userId || userIdentity.userId;
  let url = '/user-card/consume-logs?uid=' + userIdentity.uid +
    '&user_id=' + userId;
  let $httpHhy = createHttp();
  return $httpHhy.get(url);
}

/**
 * 查询会员每餐（默认段时间内）参与每餐核销限制卡券的核销历史
 */
export function timeSpanCardConsumeLog(userId = 0) {
  let userIdentity = getUserIdentity();
  userId = userId || userIdentity.userId;
  let url = '/user-card/time-span-card-consume-log?uid=' + userIdentity.uid +
    '&user_id=' + userId;
  let $httpHhy = createHttp();
  return $httpHhy.get(url);
}

export function getWelcomeImage() {
  let uid = getUserIdentity().uid + '';
  let url = '/self-order/welcome-images/' + uid;
  let $httpHhy = createHttp();
  return $httpHhy.get(url);
}

export function tableStatus () {
  let {branchId, tableNo} = getUserIdentity();
  let url = '/table-status';
  return createHttp().post(url, {
    branchId,
    tableNo
  });
}



// WEBPACK FOOTER //
// ./src/components/api/interface-hhy.js